<template>
  <div id="payment-history">
    <b-collapse
      class="card"
      animation="slide"
      v-for="(purchase, index) of purchaseHistory"
      :key="index"
      :open="isOpen == index"
      @open="isOpen = index"
    >
      <template #trigger="props">
        <div class="card-header" role="button">
          <a class="card-header-icon">
            <b-icon icon="cash-multiple" type="is-primary"></b-icon>
          </a>
          <div
            class="card-header-title is-flex-direction-column is-align-items-flex-start"
          >
            <p class="activity">
              {{ purchase.activity }}
            </p>
            <p class="datetime">
              {{ purchase.datetime.format('YYYY/MM/DD') }}
            </p>
          </div>
          <p class="card-header-title price">¥{{ purchase.price }}</p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"> </b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <dl class="paymentdetail is-clearfix">
            <dt class="paymentdetail__dt">{{ '購入日時' }}</dt>
            <dd class="paymentdetail__dd">
              {{ purchase.datetime.format('YYYY/MM/DD') }}
              {{ purchase.datetime.format('HH:mm:ss') }}
            </dd>
            <dt class="paymentdetail__dt">{{ '購入アイテム' }}</dt>
            <dd class="paymentdetail__dd">
              {{ purchase.transactionDetails.product }}
              {{ purchase.transactionDetails.amount }}コ
            </dd>
            <dt class="paymentdetail__dt">{{ '金額' }}</dt>
            <dd class="paymentdetail__dd">¥{{ purchase.price }}</dd>
            <dt class="paymentdetail__dt">{{ '決済情報' }}</dt>
            <dd class="paymentdetail__dd">
              {{ purchase.transactionDetails.paymentMethod.cardBrand }} ****
              {{ purchase.transactionDetails.paymentMethod.lastFourDigits }}
            </dd>
          </dl>
        </div>
      </div>
    </b-collapse>

    <div class="load-button-container">
      <b-button
        @click="onClickLoadPaymentHistory"
        :disabled="allHistoryLoaded"
        class="is-primary load-button"
        :loading="newHistoryLoading"
        expanded
      >
        {{ allHistoryLoaded ? 'all loaded' : '+ load more' }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentHistory',
  computed: {
    purchaseHistory() {
      return this.$store.getters['payment/paymentHistory'];
    },
    allHistoryLoaded() {
      return this.$store.getters['payment/allHistoryLoaded'];
    }
  },
  data() {
    return {
      isOpen: -1,
      newHistoryLoading: false
    };
  },
  async created() {
    await this.$store.dispatch('payment/loadPurchaseHistory', {
      userId: this.$store.state.auth.uid,
      offset: 0
    });
  },
  methods: {
    async onClickLoadPaymentHistory() {
      this.newHistoryLoading = true;
      await this.$store.dispatch('payment/loadPurchaseHistory', {
        userId: this.$store.state.auth.uid,
        offset: this.$store.state.payment.purchaseHistory.length
      });
      this.newHistoryLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/payment-history.scss';
</style>
